'use client';

import dynamic from 'next/dynamic';

/**
 * ЕДИНСТВЕНИЯТ ленив вход към `LoginPopup`.
 *
 * `Header` и `Homepage` го рендерират независимо един от друг. Ако всеки си
 * направи собствен `dynamic(() => import(...))`, webpack ги приема за различни
 * цели заради различните относителни пътища и прави ДВА async chunk-а за същия
 * модул — наблюдавано в dev: `..._LoginPopup_js-_6ed80.js` и `-_6ed81.js`, по
 * ~650 KB всеки. Освен удвоените байтове това регистрира модула два пъти в
 * runtime-а и води до „Cannot read properties of undefined (reading 'call')".
 *
 * `ssr: false` е коректен: попъпът се рендерира само зад клик и не дава нищо
 * на сървъра.
 */
export default dynamic(() => import('./LoginPopup'), { ssr: false });
